(function () {

  const iframeId = 'frame_XM-Mj6V1m5JhtH7zpv1WLA';

  function updateIframeReferrer() {
    const iframe = document.getElementById(iframeId);
    if (!iframe) return;

    // Current page URL (with bcpo params)
    const pageUrl = window.location.href;

    // Parse existing iframe src
    const iframeUrl = new URL(iframe.src);

    // Update ONLY referrer_url
    iframeUrl.searchParams.set(
      'referrer_url',
      encodeURIComponent(pageUrl)
    );

    // Apply back
    iframe.src = iframeUrl.toString();
  }

  function updateUrlFromOptions() {
    const labels = document.querySelectorAll('.bcpo-label');
    if (!labels.length) return;

    const url = new URL(window.location.href);
    let hasChange = false;

    labels.forEach(label => {
      const titleEl = label.querySelector('.bcpo-title');
      const valueEl = label.querySelector('.bcpo-value');
      if (!titleEl || !valueEl) return;

      const key = 'bcpo' + titleEl.textContent
        .replace(':', '')
        .trim()
        .replace(/\s+/g, '_')
        .toLowerCase();

      const value = valueEl.textContent.trim();

      if (url.searchParams.get(key) !== value) {
        url.searchParams.set(key, value);
        hasChange = true;
      }
    });

    if (hasChange) {
      // Update page URL
      window.history.replaceState({}, '', url.toString());

      // Update iframe referrer_url ONLY
      updateIframeReferrer();
    }
  }

  /* Initial run */
  document.addEventListener('DOMContentLoaded', function () {
    updateUrlFromOptions();
    updateIframeReferrer();
  });

  /* Observe option changes */
  const observer = new MutationObserver(updateUrlFromOptions);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

})();

